<template>
  <div
    v-if="config"
    :class="[
      props.config.gridLayoutClass || defaultGridLayoutClass,
      props.config.class,
    ]"
  >
    <div
      v-for="(widget, index) in props.config.widgets"
      :key="index"
      :class="widget.containerClass"
    >
      <WidgetContainer :data="widget" />
    </div>
  </div>
</template>

<script setup>
import { inject } from "vue";
import WidgetContainer from "~/components/WidgetContainer";

const props = defineProps({
  config: {
    type: Object,
  },
});

const { default: defaultGridLayoutClass } = inject(
  "siteConfig"
).siteConfigData.gridLayoutClasses;
</script>
